module.exports = __webpack_public_path__ + "img/category-1.e779435c.jpg";